import React, { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { SectionHeader } from "./About";

export default function Testimonials({ items }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!items.length) return;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);
  const current = items[i];
  if (!current) return null;
  return (
    <section className="py-24 md:py-32 relative border-t border-white/5" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader           number="09" overline="Signal" title="What collaborators have said." />
        <div className="mt-14 grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-2">
            <Quote className="w-20 h-20 text-volt/40" />
          </div>
          <div className="md:col-span-10">
            <p key={current.id} className="font-display font-light text-2xl sm:text-4xl leading-snug text-fog-100 tracking-tight">
              "{current.quote}"
            </p>
            <div className="mt-6 flex items-center justify-between">
              <div>
                <p className="font-display font-bold">{current.name}</p>
                <p className="text-fog-300 text-sm">{current.role} · {current.company}</p>
              </div>
              <div className="flex gap-2">
                {items.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setI(idx)}
                    className={`w-8 h-px transition-all ${idx === i ? "bg-volt w-16" : "bg-white/20"}`}
                    data-testid={`testimonial-dot-${idx}`}
                    aria-label={`show testimonial ${idx + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
